<!-- 
* @Description 
-->
<template>
  <!-- <CountTo
    :start-val="startVal"
    :end-val="Number(endVal)"
    :decimals="isInt(endVal)"
    separator=""
  /> -->
  <CountTo
    :start-val="startVal"
    :end-val="Number(endVal)"
    :decimals="isInt(endVal)"
    separator=""
  />
</template>

<script>
import CountTo from 'vue-count-to';
export default {
  data() {
    return {};
  },
  props: {
    startVal: {
      type: [Number, String],
      default: '0'
    },
    endVal: {
      type: [String,Number],
      default: '0'
    }
  },
  components: {
    CountTo
  },
  created() {},
  methods: {
	  // setNumber(){
		 //  if(((this.endVal).toString()).length>0){
			//   if(((this.endVal).toString())=='0'){
			// 	  return '0'
			//   }else{
			// 	  console.log(((this.endVal).toString()))
			// 	  if(this.endVal.indexOf(',') > -1){
			// 		  return this.removeTrailingZeros(this.endVal.replace(/,/g, "") ) 
			// 	  }else{
			// 		return this.removeTrailingZeros(this.endVal)
			// 	  }
			//   }
			  
		 //  }
		  
	  // },
	  removeTrailingZeros(numStr) {
	    return numStr.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
	  },
    isInt(val) {
      return Number(val) % 1 === 0 ? 0 : 2;
    }
  }
};
</script>

<style lang="less" scoped></style>
